import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files
import enTranslation from './locales/en/translation.json'
import esTranslation from './locales/es/translation.json'
import frTranslation from './locales/fr/translation.json'
import kmTranslation from './locales/km/translation.json'

export const resources = {
  en: {
    translation: enTranslation,
  },
  es: {
    translation: esTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  km: {
    translation: kmTranslation,
  },
}

// Export i18n instance - initialization will happen in main.jsx after React loads
export default i18n
export { LanguageDetector }

